export default __webpack_public_path__ + "static/media/sassi_4.e6638239.png";